import { BrowserModule } from '@angular/platform-browser';
import { NgbModule} from '@ng-bootstrap/ng-bootstrap';
import { NgModule } from '@angular/core';
import { HttpClientModule } from '@angular/common/http'; //, HttpClient
import {  HttpModule } from '@angular/http'; //Http,
import { Ng4LoadingSpinnerModule } from 'ng4-loading-spinner';
import { ReactiveFormsModule, FormsModule} from '@angular/forms';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ToastrModule, ToastContainerModule } from 'ngx-toastr';
import { InfiniteScrollModule } from "ngx-infinite-scroll";
import { FileUploadModule } from 'ng2-file-upload';


import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';

//Pages
import { HomeHeaderComponent } from './home-header/home-header.component';
import { HomeComponent } from './home/home.component';
import { FooterComponent } from './footer/footer.component';
import { PageNotFoundComponent }   from './not-found.component';

import { AboutUsComponent } from './about-us/about-us.component';
import { ContactUsComponent } from './contact-us/contact-us.component';
import { FaqComponent } from './faq/faq.component';
import { InrheaderComponent } from './inrheader/inrheader.component';
import { ShippingAddressComponent } from './shipping-address/shipping-address.component';
import { MyAccountComponent } from './my-account/my-account.component';
import { MyPackagesComponent } from './my-packages/my-packages.component';
import { SidebarComponent } from './sidebar/sidebar.component';
import { AccountHeaderComponent } from './account-header/account-header.component';
import { AccountFooterComponent } from './account-footer/account-footer.component';
import { AddressComponent } from './address/address.component';
import { SigninUpComponent } from './signin-up/signin-up.component';
import { ForgotPassComponent } from './forgot-pass/forgot-pass.component';
import { RateComponent } from './rate/rate.component';
import { ServiceComponent } from './service/service.component';
import { SmartshipPayComponent } from './smartship-pay/smartship-pay.component';
import { AccountVerifyComponent } from './account-verify/account-verify.component';
import { ResetPasswordComponent } from './reset-password/reset-password.component';
import { ResetpassPopupComponent } from './resetpass-popup/resetpass-popup.component';
import { AddCardComponent } from './add-card/add-card.component';
import { TexDetailComponent } from './tex-detail/tex-detail.component';
import { AddinvoiceComponent } from './addinvoice/addinvoice.component';
import { RequestDeliveryComponent } from './request-delivery/request-delivery.component';

//Provider
import { UserProvider } from './providers/user/user';
import { BasicProvider } from './providers/basic/basic';
import { AuthGuard } from './auth-guard.service';
//import { CommonService } from './providers/common.service';

//Pipes
import { MyFilterPipe } from './pipes/my-filter/my-filter';
import { AuthorizedCollectComponent } from './authorized-collect/authorized-collect.component';
import { PrePullPackageComponent } from './pre-pull-package/pre-pull-package.component';
import { AgmCoreModule } from '@agm/core';
import { environment } from '../environments/environment';
import { RequestDeliveryModalComponent } from './request-delivery-modal/request-delivery-modal.component';

@NgModule({
  imports: [
    BrowserModule,
    AppRoutingModule,
    HttpClientModule,
    HttpModule,
    FormsModule,
    ReactiveFormsModule,
    Ng4LoadingSpinnerModule,
    BrowserAnimationsModule,
    InfiniteScrollModule,
    FileUploadModule,
    ToastrModule.forRoot({ positionClass: 'toast-top-right', maxOpened:1, autoDismiss:true, closeButton:true }),
    ToastContainerModule,
    NgbModule.forRoot(),
    AgmCoreModule.forRoot({
      apiKey: environment.googleMapsApiKey,
      libraries: ['places']
    })

  ],
  declarations: [
    AppComponent,
    HomeHeaderComponent,
    HomeComponent,
    FooterComponent,
    AboutUsComponent,
    ContactUsComponent,
    FaqComponent,
    InrheaderComponent,
    ShippingAddressComponent,
    MyAccountComponent,
    MyPackagesComponent,
    SidebarComponent,
    AccountHeaderComponent,
    AccountFooterComponent,
    AddressComponent,
    SigninUpComponent,
    ForgotPassComponent,
    RateComponent,
    ServiceComponent,
    SmartshipPayComponent,
    AccountVerifyComponent,
    ResetPasswordComponent,
    ResetpassPopupComponent,
    AddCardComponent,
    TexDetailComponent,
    AddinvoiceComponent,
    RequestDeliveryComponent,
    MyFilterPipe,
    //FileSelectDirective,
    PageNotFoundComponent,
    AuthorizedCollectComponent,
    PrePullPackageComponent,
    RequestDeliveryModalComponent,
  ],
  entryComponents: [
    SigninUpComponent,
    ForgotPassComponent,
    ResetpassPopupComponent,
    RequestDeliveryModalComponent
  ],
  providers: [
    UserProvider,
    BasicProvider,
    AuthGuard,
    //CommonService,
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// ./src/app/app.module.ts